// Libraries
import { AppThunk } from '@redux/configureStore';
// Internal imports
import { createSlice } from '@reduxjs/toolkit';
// Types
import { IResumeLiquidationState } from './types';
// Api
import { apiPostContractLiquidation } from '@api/resumeLiquidation';
// Models
import { IGetOrCreateContractLiquidation } from '@models/ResumeLiquidation';
import { IPaymentValues } from '@pages/payroll-adjuster/models/PaymentValues';
// Pages
import { INITIAL_VALUES_LIQUIDATION_CONTRACT } from '@pages/resume-liquidation/constants/ResumeLiquidation';
// Redux
import { putUpdateEmployee } from '@redux/employee/employee.slice';

const initialState: IResumeLiquidationState = {
    contractLiquidationInfo: INITIAL_VALUES_LIQUIDATION_CONTRACT,
    errorLiquidationContract: '',
    employeesLiquidationContract: [],
    showModalSuperposition: false,
    error: '',
};

const resumeLiquidationSlice = createSlice({
    name: 'resumeLiquidation',
    initialState,
    reducers: {
        setGetOrCreateContractLiquidation: (state, action) => {
            state.contractLiquidationInfo = action.payload || null;
        },
        setGetErrorLiquidationContract: (state, action) => {
            state.errorLiquidationContract = action.payload || '';
        },
        setAlreadySaved: (state, action) => {
            state.employeesLiquidationContract = [...state.employeesLiquidationContract, action.payload];
        },
        setShowModalSuperposition: (state, action) => {
            state.showModalSuperposition = action.payload;
        },
        failedRequest: (state, action) => {
            state.error = action.payload;
        },
    },
});

export const getOrCreateContractLiquidation = (
    data: IGetOrCreateContractLiquidation,
    paymentData: IPaymentValues | null = {
        account_number: '',
        payment_method_id: '',
        bank_id: '',
        bank_account_type_id: '',
    }
): AppThunk => {
    return async (dispatch, getState): Promise<void> => {
        const {
            payrollAdjuster: { currentEmployee },
        } = getState();
        try {
            const { employee_id, is_save } = data;

            const response = (await apiPostContractLiquidation({ ...data })) as unknown as {
                message: string;
                is_successful: boolean;
            };

            if (response?.message) {
                dispatch(setGetErrorLiquidationContract(response?.message));
            } else {
                dispatch(setGetOrCreateContractLiquidation(response?.message || response));

                if (is_save) {
                    const data = {
                        employee: {
                            id: currentEmployee?.id,
                            ...paymentData,
                            bank_account_type_id: paymentData?.bank_account_type_id,
                        },
                        update_pila: false,
                    };

                    dispatch(putUpdateEmployee(currentEmployee?.id, data, true, (): void => {}));
                    dispatch(setAlreadySaved(employee_id));
                }
            }

            if (!response.is_successful) {
                dispatch(setShowModalSuperposition(true));
                return;
            }
        } catch (error) {
            dispatch(failedRequest('Error request data'));
        }
    };
};

export const {
    setGetOrCreateContractLiquidation,
    setGetErrorLiquidationContract,
    setAlreadySaved,
    setShowModalSuperposition,
    failedRequest,
} = resumeLiquidationSlice.actions;

export default resumeLiquidationSlice.reducer;
